module.exports = __webpack_public_path__ + "img/Sintomas Cancro Europeu na Colheita 2.7536824b.webp";